export default __webpack_public_path__ + "static/media/success-tick.873eca67.svg";